<template>
    <button
        class="rounded text-white px-4 py-2 shadow-sm flex items-center space-x-1 hover:opacity-80 hover:shadow"
        :style="'background: ' + cor + '; text-shadow: 0 -1px rgba(0, 0, 0, 0.2);'"
        data-editor="primaryColor"
        @click="$emit('click')"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    computed: {
        cor() {
            return this.$store.getters.corPrimária
        },
    },
}
</script>